<a class="d-flex" style="text-decoration: none; color: inherit;" [routerLink]="['/']">
    <span class="pe-1 fs-5 lh-1">my</span>
    <img src="/logo_red.svg" height="25" />
</a>
